import React, { useEffect, useRef } from 'react';
import './SponsorBar.css';
import sponsorsData, { getAllSponsors } from './sponsorData';

const SponsorBar = () => {
  const scrollRef = useRef(null);

  // Get sponsors from our centralized data file
  const sponsors = getAllSponsors();
  
  // Double the sponsors array to create continuous scrolling effect
  const allSponsors = [...sponsors, ...sponsors];

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let animationId;
    let position = 0;
    
    const scroll = () => {
      if (!scrollContainer) return;
      
      // Increment position to create scrolling effect
      position += 0.5;
      
      // Reset position when we've scrolled half the content (to create seamless loop)
      if (position >= scrollContainer.scrollWidth / 2) {
        position = 0;
      }
      
      scrollContainer.scrollLeft = position;
      animationId = requestAnimationFrame(scroll);
    };
    
    // Start the scrolling animation
    animationId = requestAnimationFrame(scroll);
    
    // Pause scrolling when user hovers
    const handleMouseEnter = () => {
      cancelAnimationFrame(animationId);
    };
    
    const handleMouseLeave = () => {
      animationId = requestAnimationFrame(scroll);
    };
    
    scrollContainer.addEventListener('mouseenter', handleMouseEnter);
    scrollContainer.addEventListener('mouseleave', handleMouseLeave);
    
    // Clean up
    return () => {
      cancelAnimationFrame(animationId);
      if (scrollContainer) {
        scrollContainer.removeEventListener('mouseenter', handleMouseEnter);
        scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, []);

  // Handle sponsor click to open their website
  const handleSponsorClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="sponsor-bar-container">
      <div className="sponsor-bar-label">OUR SPONSORS</div>
      <div className="sponsor-bar-wrapper">
        <div className="sponsor-bar" ref={scrollRef}>
          {allSponsors.map((sponsor, index) => (
            <div 
              key={`${sponsor.id}-${index}`} 
              className="sponsor-item"
              onClick={() => handleSponsorClick(sponsor.url)}
              title={`Visit ${sponsor.name}`}
            >
              <img 
                src={sponsor.logo} 
                alt={`${sponsor.name} logo`} 
                className={`sponsor-logo ${sponsor.needsInversion ? 'inverted-logo' : ''}`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SponsorBar;